import { render, staticRenderFns } from "./SupportAssistant.vue?vue&type=template&id=1478774a&scoped=true"
import script from "./SupportAssistant.vue?vue&type=script&lang=ts"
export * from "./SupportAssistant.vue?vue&type=script&lang=ts"
import style0 from "./SupportAssistant.vue?vue&type=style&index=0&id=1478774a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478774a",
  null
  
)

export default component.exports